"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const next_i18next_1 = require("next-i18next");
const config_1 = __importDefault(require("next/config"));
const react_1 = __importDefault(require("react"));
const react_google_recaptcha_1 = __importDefault(require("react-google-recaptcha"));
const components_common_error_message_1 = require("@hotelplan/components.common.error-message");
const fdr_catalogs_order_recaptcha_styles_1 = require("./fdr-catalogs-order-recaptcha.styles");
const FdrCatalogsOrderRecaptcha = ({ formik, }) => {
    const [t] = (0, next_i18next_1.useTranslation)('forms');
    const { publicRuntimeConfig } = (0, config_1.default)();
    return (react_1.default.createElement(fdr_catalogs_order_recaptcha_styles_1.ReCaptchaWrapper, null,
        react_1.default.createElement(react_google_recaptcha_1.default, { sitekey: publicRuntimeConfig.recaptchaSiteKey, onChange: token => {
                formik.setFieldValue('recaptchaToken', token);
            }, onExpired: () => {
                formik.setFieldValue('recaptchaToken', '');
            }, onErrored: () => {
                formik.setFieldValue('recaptchaToken', '');
            } }),
        react_1.default.createElement(components_common_error_message_1.ErrorMessage, { getMessage: message => t(message), error: formik.errors.recaptchaToken })));
};
exports.default = FdrCatalogsOrderRecaptcha;
//# sourceMappingURL=fdr-catalogs-order-recaptcha.js.map